const serviceInfo = () => {
    if($(".service-info h3").length) {
        new SplitText(".service-info h3", {
            type: "lines",
            linesClass: "line line++"
        });
    }

    if($(".service-info h4").length) {
        new SplitText(".service-info h4", {
            type: "lines",
            linesClass: "line line++"
        });
    }

    if($(".service-rates h3").length) {
        new SplitText(".service-rates h3", {
            type: "lines",
            linesClass: "line line++"
        });
    }
};

export default serviceInfo;